const EVENTS_INITIAL_STATE = {
  isFetchEventsLoading: false,
  fetchEventsError: undefined,
  eventsData: undefined,
  isFetchLatestEventByEntityTypesLoading: false,
  fetchFetchLatestEventByEntityTypesError: undefined,
  latestEventByEntityTypesData: undefined,
}

export default EVENTS_INITIAL_STATE
